// extracted by mini-css-extract-plugin
export var messageSideLeft = "_kb-1";
export var messageSideRight = "_kb-2";
export var subscribeToBackInStockBubbleContainer = "_kb-0";